import {useState, useEffect} from "react";
import DropdownBase from "./FieldTypeBase/DropdownBase";
import ReactDOM from "react-dom";

const DropdownInLine = (props) => {
    const [container, setContainer] = useState(null);

   useEffect(() => {
    let attempts = 0;
    const interval = setInterval(() => {
        const el = document.getElementById(props.field.containerId);
        if (el) {
        setContainer(el);
        clearInterval(interval);
        } else if (attempts++ > 10) {
        clearInterval(interval);
        console.warn("Portal container not found:", props.field.containerId);
        }
    }, 100); // retry every 100ms up to 1s

  return () => clearInterval(interval);
}, [props.field.containerId]);

    if (!container) return null;
   
    return  ReactDOM.createPortal(
        
        <span            
            id={props.objectkey}          
            className={`field ${props.field.class || ""}`}>

            <DropdownBase {...props}></DropdownBase>
                
        </span>
        
        ,container // <- target container 
    );
}

export default DropdownInLine;